module.exports = __webpack_public_path__ + "assets/28b763035d5c951d5f99e22da607188b.png";